exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-view[data-v-40750c4a]{\n    margin-top: 80px;\n}\n", ""]);

// exports
